import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { JSX } from 'react';
import { NumericFormat, numericFormatter, OnValueChange } from 'react-number-format';

export const thousandSeparator = ',';

/**
 * Convert formatted number string back to number
 */
export const formattedValueToNumber = (value?: string): number => {
  return value ? Number(value.replace(thousandSeparator, '') || 0) : 0;
};

/**
 * Format number to string with thousands separator
 */
export const formatNumber = (value?: number | string, prefix?: string, suffix?: string): string =>
  numericFormatter(String(value), { thousandSeparator, prefix, suffix });

/**
 * Format amount to string with thousands separator and currency prefix (with rounding to nearest integer)
 */
export const formatAmount = (value?: number | string): string =>
  formatNumber(Math.round(Number(value)), 'R ');

/**
 * Edit cell for numeric values with formatted input
 */
const DataGridEditNumberCell = ({ id, value, field }: GridRenderEditCellParams): JSX.Element => {
  const apiRef = useGridApiContext();

  const handleValueChange: OnValueChange = (values): void => {
    apiRef.current.setEditCellValue({ id, field, value: values.floatValue });
  };

  return (
    <NumericFormat
      className="w-full h-full p-2"
      autoFocus
      thousandSeparator={thousandSeparator}
      value={value || ''}
      onValueChange={handleValueChange}
    />
  );
};

export default DataGridEditNumberCell;
